import { render, staticRenderFns } from "./accorDion.vue?vue&type=template&id=22ff90ed&scoped=true"
import script from "./accorDion.vue?vue&type=script&lang=js"
export * from "./accorDion.vue?vue&type=script&lang=js"
import style0 from "./accorDion.vue?vue&type=style&index=0&id=22ff90ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ff90ed",
  null
  
)

export default component.exports